import { useState } from 'react';
import { submitFeedback } from '../services/api';

const INITIAL_FORM = {
  name: '',
  email: '',
  message: '',
};

function FeedbackModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [form, setForm] = useState(INITIAL_FORM);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const close = () => {
    setIsOpen(false);
    setStatus('idle');
    setError('');
  };

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('submitting');
    setError('');

    try {
      await submitFeedback({
        name: form.name.trim(),
        email: form.email.trim(),
        message: form.message.trim(),
      });
      setForm(INITIAL_FORM);
      setStatus('sent');
    } catch (err) {
      setError(err.message || 'Failed to send feedback.');
      setStatus('idle');
    }
  };

  return (
    <>
      <button
        className="feedback-fab"
        type="button"
        aria-label="Give feedback"
        title="Give feedback"
        onClick={() => setIsOpen(true)}
      >
        <i className="fa-solid fa-comment-dots" />
      </button>

      {isOpen && (
        <div className="feedback-backdrop" onMouseDown={close}>
          <div
            className="feedback-card"
            role="dialog"
            aria-modal="true"
            aria-labelledby="feedback-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className="feedback-header">
              <h2 id="feedback-title">We value your feedback</h2>
              <button type="button" aria-label="Close" onClick={close}>
                <i className="fa-solid fa-xmark" />
              </button>
            </div>

            {status === 'sent' ? (
              <div className="feedback-success">
                <p>Thank you for your feedback.</p>
                <button type="button" onClick={close}>Done</button>
              </div>
            ) : (
              <form className="feedback-form" onSubmit={handleSubmit}>
                <label htmlFor="feedback-name">Name</label>
                <input
                  id="feedback-name"
                  name="name"
                  value={form.name}
                  onChange={updateField}
                  required
                  placeholder="Your name"
                />

                <label htmlFor="feedback-email">Email (optional)</label>
                <input
                  id="feedback-email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={updateField}
                  placeholder="you@example.com"
                />

                <label htmlFor="feedback-message">Message</label>
                <textarea
                  id="feedback-message"
                  name="message"
                  value={form.message}
                  onChange={updateField}
                  required
                  placeholder="Share your thoughts..."
                />

                {error && <p className="feedback-error">{error}</p>}

                <div className="feedback-actions">
                  <button type="button" onClick={close}>Cancel</button>
                  <button type="submit" disabled={status === 'submitting'}>
                    {status === 'submitting' ? 'Sending...' : 'Send feedback'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default FeedbackModal;
